import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import { ADMIN_MODULES } from "./config/adminConfigs";
import NewsAdminPage from "./pages/NewsAdminPage";
import EpaperAdminPage from "./pages/EpaperAdminPage";
import ModulePlaceholderPage from "./pages/ModulePlaceholderPage";
import SubscriptionPricingPage from "./pages/SubscriptionPricingPage";
import SpecialPlanRequestsPage from "./pages/SpecialPlanRequestsPage";
import CategoriesPage from "./pages/CategoriesPage";

const buildAdminRoutes = () => {
  const seenPaths = new Set();
  const routes = [];

  ADMIN_MODULES.forEach((module) => {
    module.navItems.forEach((item) => {
      if (seenPaths.has(item.path)) return;
      seenPaths.add(item.path);

      const linkedEpaperModule = ADMIN_MODULES.find(
        (candidate) =>
          candidate.kind === "epaper" &&
          (item.path === candidate.mainPath || item.path === `${candidate.basePath}/dashboard`)
      );
      const isMainNews = module.kind === "news" && item.path === module.mainPath;
      const isLinkedEpaperDashboard =
        linkedEpaperModule && item.path === `${linkedEpaperModule.basePath}/dashboard`;
      const isSubscriptionPricing =
        module.kind === "epaper" && item.path === `${module.basePath}/subscription_pricing`;
      // "Dashboard" nav items don't have their own page — they're meant to
      // land on the module's real main page. E-Paper modules already got
      // this via linkedEpaperModule above; news modules didn't, so their
      // Dashboard link fell through to the empty ModulePlaceholderPage.
      const isNewsDashboard =
        module.kind === "news" && item.path === `${module.basePath}/dashboard`;

      const isSpecialPlanRequests =
        module.kind === "epaper" && item.path === `${module.basePath}/special_plan_requests`;

      const isCategories =
        module.kind === "news" && item.path === `${module.basePath}/categories`;

      const element = isSubscriptionPricing ? (
        <SubscriptionPricingPage module={module} />
      ) : isCategories ? (
        <CategoriesPage module={module} />
      ) : isSpecialPlanRequests ? (
        <SpecialPlanRequestsPage module={module} />
      ) : linkedEpaperModule ? (
        isLinkedEpaperDashboard ? (
          <Navigate to={linkedEpaperModule.mainPath} replace />
        ) : (
          <EpaperAdminPage module={linkedEpaperModule} />
        )
      ) : isNewsDashboard ? (
        <Navigate to={module.mainPath} replace />
      ) : isMainNews ? (
        <NewsAdminPage module={module} />
      ) : (
        <ModulePlaceholderPage module={module} item={item} />
      );

      routes.push(
        <Route
          key={item.path}
          path={item.path}
          element={
            <ProtectedRoute roles={["admin", "editor"]}>
              {element}
            </ProtectedRoute>
          }
        />
      );
    });
  });

  return routes;
};

const App = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/" element={<Navigate to="/janmabhoomi_admin/manage_news" replace />} />
    {buildAdminRoutes()}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
